import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "filterDrawer",
    "filterBackground",
    "checkoutDrawer",
    "checkoutBackground",
  ];

  toggleFilterHidden() {
    this.filterBackgroundTarget.classList.toggle("hidden");
    this.filterDrawerTarget.classList.toggle("drawer-open");
    document.body.classList.toggle("overflow-hidden");
  }

  toggleCheckoutHidden() {
    this.checkoutBackgroundTarget.classList.toggle("hidden");
    this.checkoutDrawerTarget.classList.toggle("drawer-open");
    document.body.classList.toggle("overflow-hidden");
  }
}
